<template>
  <div class="myParkEditOrDetail">
    <el-dialog :title="detailTitle"
               :visible.sync="parkEditOrDetailVisible"
               v-dialogDrag
               top="7vh"
               left="0vh"
               width="60%">
      <el-tabs v-model="editOrDetail"
               tab-position="left"
               type="card"
               @tab-click="tab_click">
        <el-tab-pane label="基本信息"
                     name="editBaseInfo">
          <el-form :model="curRowInfo"
                   :inline="true"
                   label-width="100px">
            <el-row class="parkMain_BaseInfo">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="客户名称::">
                    <el-select v-model="curRowInfo.fCustID"
                               filterable
                               placeholder="请选择客户"
                               :disabled="!curRowInfo.isEdit||curRowInfo.op=='edit'"
                               style="width:250px;"
                               @change="custChange">
                      <el-option v-for="item in choiceCusts"
                                 :key="item.fCustID"
                                 :label="item.unionName"
                                 :value="item.fCustID">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="13">
                  <el-form-item label="场库编号::">
                    <el-input v-model="curRowInfo.fParkNo"
                              style="width:250px;"
                              :disabled="!curRowInfo.isEdit"></el-input>
                    <span style="color:red;margin-top:6px;margin-left:6px;">场库编号只允许输入字母和数字</span>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="场库类型::">
                    <el-select v-model="curRowInfo.fParkTypeID"
                               placeholder="请选择场库类型"
                               style="width:250px;"
                               :disabled="!curRowInfo.isEdit">
                      <el-option v-for="item in parkTypeList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="场库名称::">
                    <el-input v-model="curRowInfo.fParkName"
                              style="width:250px;"
                              :disabled="!curRowInfo.isEdit"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="13">
                  <el-form-item label="联系人::">
                    <el-input v-model="curRowInfo.fLinkman"
                              style="width:250px;"
                              :disabled="!curRowInfo.isEdit"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="联系电话::">
                    <el-input v-model="curRowInfo.fLinkPhone"
                              style="width:250px;"
                              :disabled="!curRowInfo.isEdit"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="13">
                  <el-form-item label="车位数量::">
                    <el-input v-model="curRowInfo.fParkCount"
                              style="width:250px;"
                              :disabled="!curRowInfo.isEdit"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="保留车位数量::">
                    <el-input v-model="curRowInfo.fResCount"
                              style="width:250px;"
                              :disabled="!curRowInfo.isEdit"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="场库地址::">
                    <el-input v-model="curRowInfo.fAddress"
                              :disabled="!curRowInfo.isEdit"
                              style="width:815px"
                              id="mapInput"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8" style="width:315px">
                  <el-form-item label="经度::">
                    <el-input v-model="curRowInfo.fLongitude"
                              :disabled="!curRowInfo.isEdit"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8" style="width:315px">
                  <el-form-item label="纬度::">
                    <el-input v-model="curRowInfo.fLatitude"
                              :disabled="!curRowInfo.isEdit"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8" style="width:315px">
                  <el-form-item label="高度::">
                    <el-input v-model="curRowInfo.fHigh"
                              :disabled="!curRowInfo.isEdit"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label=" "
                                style="height:300px;">
                    <div class="search_list"
                         v-if="map_search_list.length > 0">
                      <el-row :key="index"
                              v-for="(item, index) in map_search_list"
                              @click.native="map_search_change(item, index)">
                        <el-col class="t"
                                :span="24"
                                v-html="item.title"></el-col>
                        <el-col class="a"
                                :span="24"
                                v-html="item.address"></el-col>
                      </el-row>
                    </div>
                    <div id="parkBaiduMap"
                         :style="{ width: (map_search_list.length > 0 ?'515px':'815px'), height:'300px' }"></div>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-row>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="费率设置"
                     name="rateSetting">
          <el-form :model="parkSetting"
                   :inline="true"
                   label-width="180px"
                   style="margin-top:10px;">
            <el-row>
              <el-col :span="12">
                <el-form-item label="临时车费率组::">
                  <el-select v-model="parkSetting.p10010"
                             placeholder="请选择"
                             style="width:160px"
                             :disabled="!curRowInfo.isEdit">
                    <el-option v-for="item in rateSelectList"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="蓝牌车费率组::">
                  <el-select v-model="parkSetting.p10020"
                             placeholder="请选择"
                             style="width:160px"
                             :disabled="!curRowInfo.isEdit">
                    <el-option v-for="item in rateSelectList"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="绿牌车费率组::">
                  <el-select v-model="parkSetting.p10021"
                             placeholder="请选择"
                             style="width:160px"
                             :disabled="!curRowInfo.isEdit">
                    <el-option v-for="item in rateSelectList"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="黄牌车费率组::">
                  <el-select v-model="parkSetting.p10022"
                             placeholder="请选择"
                             style="width:160px"
                             :disabled="!curRowInfo.isEdit">
                    <el-option v-for="item in rateSelectList"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="教练车费率组(学)::">
                  <el-select v-model="parkSetting.p10026"
                             placeholder="请选择"
                             style="width:160px"
                             :disabled="!curRowInfo.isEdit">
                    <el-option v-for="item in rateSelectList"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="港澳白牌车费率组::">
                  <el-select v-model="parkSetting.p10011"
                             placeholder="请选择"
                             style="width:160px"
                             :disabled="!curRowInfo.isEdit">
                    <el-option v-for="item in rateSelectList"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="港澳黑牌车费率组::">
                  <el-select v-model="parkSetting.p10012"
                             placeholder="请选择"
                             style="width:160px"
                             :disabled="!curRowInfo.isEdit">
                    <el-option v-for="item in rateSelectList"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="非本场库月卡车费率组::">
                  <el-select v-model="parkSetting.p10024"
                             placeholder="请选择"
                             style="width:160px"
                             :disabled="!curRowInfo.isEdit">
                    <el-option v-for="item in rateSelectList"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="临时车无入场记录费率组::">
                  <el-select v-model="parkSetting.p10023"
                             placeholder="请选择"
                             style="width:160px"
                             :disabled="!curRowInfo.isEdit">
                    <el-option v-for="item in rateSelectList"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="包月车无入场记录费率组::">
                  <el-select v-model="parkSetting.p10025"
                             placeholder="请选择"
                             style="width:160px"
                             :disabled="!curRowInfo.isEdit">
                    <el-option v-for="item in rateSelectList"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="月车以临时车在场时费率组::">
                  <el-select v-model="parkSetting.p10028"
                             placeholder="请选择"
                             style="width:160px"
                             :disabled="!curRowInfo.isEdit">
                    <el-option v-for="item in rateSelectList"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="过期包月车费率组::">
                  <el-select v-model="parkSetting.p10031"
                             placeholder="请选择"
                             style="width:160px"
                             :disabled="!curRowInfo.isEdit">
                    <el-option v-for="item in rateSelectList"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="手持机出场收费费率组::">
                  <el-select v-model="parkSetting.p10027"
                             placeholder="请选择"
                             style="width:160px"
                             :disabled="!curRowInfo.isEdit">
                    <el-option v-for="item in rateSelectList"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="默认车牌首字::">
                  <el-input v-model="parkSetting.p10230"
                            style="width:160px"
                            :disabled="!curRowInfo.isEdit"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="数据库中图片保存时间::">
                  <el-select v-model="parkSetting.p10170"
                             placeholder="请选择"
                             style="width:160px"
                             :disabled="!curRowInfo.isEdit">
                    <el-option v-for="item in parkPicSaveList"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="免费时间(分钟)::">
                  <el-input v-model="parkSetting.p10030"
                            style="width:160px"
                            :disabled="!curRowInfo.isEdit"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="自动删除超过::">
                  <el-select v-model="parkSetting.p10350"
                             placeholder="请选择"
                             style="width:100px"
                             :disabled="!curRowInfo.isEdit">
                    <el-option v-for="item in autoDelDataList"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                  <span>在场数据</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="ETC扣费上限(元)(0不启用)::">
                  <el-input v-model="parkSetting.p10420"
                            style="width:160px"
                            :disabled="!curRowInfo.isEdit"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="无感扣费上限(元)(0不启用)::">
                  <el-input v-model="parkSetting.p10430"
                            style="width:160px"
                            :disabled="!curRowInfo.isEdit"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="P+R当次停车的封顶金额::">
                  <el-input v-model="parkSetting.p10431"
                            style="width:160px"
                            :disabled="!curRowInfo.isEdit"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="P+R自动扣费上限::">
                  <el-input v-model="parkSetting.p14032"
                            style="width:160px"
                            :disabled="!curRowInfo.isEdit"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="绿牌车自然日非首次进场费率组::">
                  <el-select v-model="parkSetting.p10029"
                             placeholder="请选择"
                             style="width:160px"
                             :disabled="!curRowInfo.isEdit">
                    <el-option v-for="item in rateSelectList"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="场库设置"
                     name="editParkInfo">
          <el-form :model="parkSetting"
                   :inline="true"
                   label-width="160px"
                   style="margin-top:10px;">
            <el-row>
              <el-col :span="8">
                <el-form-item label="车满处理[临时车]::">
                  <el-select v-model="parkSetting.p10105"
                             placeholder="请选择"
                             style="width:160px"
                             :disabled="!curRowInfo.isEdit">
                    <el-option v-for="item in parkFullTmpMgrList"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="临时车进场时间::">
                  <el-select v-model="parkSetting.p10250"
                             :disabled="!curRowInfo.isEdit"
                             style="width:85px"
                             filterable>
                    <el-option v-for="item in tmpCarInTimeList"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                  <span style="width:10px">-</span>
                  <el-select v-model="parkSetting.p10260"
                             :disabled="!curRowInfo.isEdit"
                             style="width:85px;"
                             filterable>
                    <el-option v-for="item in tmpCarInTimeList"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="车满处理[包月车]::">
                  <el-select v-model="parkSetting.p10106"
                             placeholder="请选择"
                             style="width:160px"
                             :disabled="!curRowInfo.isEdit">
                    <el-option v-for="item in parkFullMonMgrList"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="包月车进场时间::">
                  <el-select v-model="parkSetting.p10270"
                             :disabled="!curRowInfo.isEdit"
                             style="width:85px"
                             filterable>
                    <el-option v-for="item in tmpCarInTimeList"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                  <span style="width:10px">-</span>
                  <el-select v-model="parkSetting.p10280"
                             :disabled="!curRowInfo.isEdit"
                             style="width:85px;"
                             filterable>
                    <el-option v-for="item in tmpCarInTimeList"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label=" "
                              label-width="40px">
                  <el-checkbox v-model="parkSetting.p10092"
                               :disabled="!curRowInfo.isEdit">包月车允许跨场库进场</el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="车满处理[绿牌车]::">
                  <el-select v-model="parkSetting.p10107"
                             placeholder="请选择"
                             style="width:160px"
                             :disabled="!curRowInfo.isEdit">
                    <el-option v-for="item in parkFullGreenMgrList"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item label=" "
                              label-width="40px">
                  <el-checkbox v-model="parkSetting.p10040"
                               :disabled="!curRowInfo.isEdit">本停车场支持月卡车辆停放</el-checkbox>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="月卡车上限(0值不限)::">
                  <el-input v-model="parkSetting.p10050"
                            :disabled="!curRowInfo.isEdit||!parkSetting.p10040"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label=" "
                              label-width="15px">
                  <el-checkbox v-model="parkSetting.p10290"
                               :disabled="!curRowInfo.isEdit">VIP免费包月车不计算车位数</el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item label=" "
                              label-width="40px">
                  <el-checkbox v-model="parkSetting.p10060"
                               :disabled="!curRowInfo.isEdit">本停车场支持临时车辆停放</el-checkbox>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="临时车上限(0值不限)::">
                  <el-input v-model="parkSetting.p10070"
                            :disabled="!curRowInfo.isEdit||!parkSetting.p10060"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="绿牌临时车上限(0值不限)::"
                              label-width="180px">
                  <el-input v-model="parkSetting.p10071"
                            style="width:100px"
                            :disabled="!curRowInfo.isEdit||!parkSetting.p10060"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label=" "
                              label-width="40px">
                  <el-checkbox v-model="parkSetting.p10080"
                               :disabled="!curRowInfo.isEdit">满位屏显示的可用车位数量需要减去保留车位数量</el-checkbox>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="预支付免费出场时间(分钟)::"
                              label-width="170px">
                  <el-input v-model="parkSetting.p10180"
                            :disabled="!curRowInfo.isEdit"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label-width="40px"
                              label=" ">
                  <el-checkbox v-model="parkSetting.p10190"
                               :disabled="!curRowInfo.isEdit">包月车识别允许一位不同</el-checkbox>
                  <el-checkbox v-model="parkSetting.p10090"
                               :disabled="!curRowInfo.isEdit">军车自由通行</el-checkbox>
                  <el-checkbox v-model="parkSetting.p10091"
                               :disabled="!curRowInfo.isEdit">警车自由通行</el-checkbox>
                  <el-checkbox v-model="parkSetting.p10093"
                               :disabled="!curRowInfo.isEdit">民航车辆自由通行</el-checkbox>
                  <el-checkbox v-model="parkSetting.p10240"
                               :disabled="!curRowInfo.isEdit">异常进出场车辆免费放行</el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label-width="40px"
                              label=" ">
                  <el-checkbox v-model="parkSetting.p10210"
                               :disabled="!curRowInfo.isEdit">无牌车允许进场</el-checkbox>
                  <el-checkbox v-model="parkSetting.p10440"
                               :disabled="!curRowInfo.isEdit">无牌车进场自动开闸</el-checkbox>
                  <el-checkbox v-model="parkSetting.p10450" style="display:none"
                               :disabled="!curRowInfo.isEdit">包月车自动下发到相机白名单(仅限于ZS-100相机)</el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="出场车辆识别处理方式::">
                  <el-select v-model="parkSetting.p10390"
                             placeholder="请选择"
                             :disabled="!curRowInfo.isEdit">
                    <el-option v-for="item in carOuterLists"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="">
                  <el-checkbox v-model="parkSetting.p10470"
                               :disabled="!curRowInfo.isEdit">一次停车只能使用一张优惠券</el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="无进场记录车出场方式::">
                  <el-select v-model="parkSetting.p10220"
                             placeholder="请选择"
                             :disabled="!curRowInfo.isEdit">
                    <el-option v-for="item in parkNoInDataList"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="本场库交班方式::">
                  <el-select v-model="parkSetting.p10200"
                             placeholder="请选择"
                             :disabled="!curRowInfo.isEdit">
                    <el-option v-for="item in parkPassWorkTypeList"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="一户多车处理方式::">
                  <el-select v-model="parkSetting.p10160"
                             placeholder="请选择"
                             style="width:300px"
                             :disabled="!curRowInfo.isEdit">
                    <el-option v-for="item in mulCarList"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="车辆出场方式::">
                  <el-select v-model="parkSetting.p10150"
                             placeholder="请选择"
                             :disabled="!curRowInfo.isEdit">
                    <el-option v-for="item in carOuterList"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 这一块内容隐藏掉，目前临时车只能自动开闸 -->
            <el-row v-if="false">
              <el-col :span="8">
                <el-form-item label="临时车入场方式::">
                  <el-select v-model="parkSetting.p10110"
                             placeholder="请选择"
                             style="width:160px"
                             :disabled="!curRowInfo.isEdit">
                    <el-option v-for="item in tmpCarEnterList"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8"
                      v-if="parkSetting.p10110=='2'">
                <el-form-item label="等待延时（秒）::">
                  <el-select v-model="parkSetting.p10112"
                             placeholder="请选择"
                             style="width:160px"
                             :disabled="!curRowInfo.isEdit">
                    <el-option v-for="item in tmpInDelayTimeList"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8"
                      v-if="parkSetting.p10110=='2'">
                <el-form-item label="超时处理::">
                  <el-select v-model="parkSetting.p10111"
                             placeholder="请选择"
                             style="width:160px"
                             :disabled="!curRowInfo.isEdit">
                    <el-option v-for="item in tmpTimeOutInTypeList"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label-width="500px" label="本场库车辆在以下时段出场需要人工确认(起始结束时间一样时取消时段限制)::">
                  <el-select v-model="parkSetting.p10475"
                             :disabled="!curRowInfo.isEdit"
                             style="width:85px"
                             filterable>
                    <el-option v-for="item in tmpCarInTimeList"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                  <span style="width:10px">-</span>
                  <el-select v-model="parkSetting.p10476"
                             :disabled="!curRowInfo.isEdit"
                             style="width:85px;"
                             filterable>
                    <el-option v-for="item in tmpCarInTimeList"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="敏感车牌关键字提醒::">
                  <el-input v-model="parkSetting.p10360"
                            placeholder="请用分号分隔多个车牌号"
                            style="width:300px"
                            :disabled="!curRowInfo.isEdit"></el-input>
                  <span style="color:red">示例：如设置"沪A"，则包含"沪A"的字符的车牌车辆进场都会弹框提醒</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="敏感车牌车辆放行理由::">
                  <el-input v-model="parkSetting.p10361"
                            placeholder="请用分号分隔多个放行理由"
                            style="width:500px"
                            :disabled="!curRowInfo.isEdit"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label=" "
                              label-width="40px">
                  <el-checkbox v-model="parkSetting.p10340"
                               :disabled="!curRowInfo.isEdit">本场库只允许绿牌车进场</el-checkbox>
                  <el-checkbox v-model="parkSetting.p10300"
                               :disabled="!curRowInfo.isEdit">出场检查违章信息</el-checkbox>
                  <el-checkbox v-model="parkSetting.p10460"
                               :disabled="!curRowInfo.isEdit">预付费充值月卡播报/显示剩余金额</el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="月车有效期少于">
                  <el-input v-model="parkSetting.p10471"
                            style="width:50px"
                            :disabled="!curRowInfo.isEdit"></el-input> &nbsp;天时播报剩余天数（0值不播报剩余天数）
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label-width="230px" label="本系统允许录入的最大包月车数量::">
                  <el-input v-model="parkSetting.p10477"
                            style="width:100px"
                            :disabled="!curRowInfo.isEdit"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="其他设置"
                     name="editRoadOther">
          <fieldset style="border:1px solid #ccc;">
            <legend>第三方数据推送</legend>
            <el-form :model="parkSetting"
                     :inline="true"
                     label-width="150px">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="进出数据自动上报地址::">
                    <el-input v-model="parkSetting.p10370"
                              :disabled="!curRowInfo.isEdit"
                              style="width:500px">
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label=" ">
                    <el-checkbox v-model="parkSetting.p10372"
                                 :disabled="!curRowInfo.isEdit">不上传进出图片数据（由于图片比较大，可能需要更改Web服务器相关设置才能正确传输）</el-checkbox>
                    <el-checkbox v-model="parkSetting.p10373"
                                 :disabled="!curRowInfo.isEdit">不上传金额相关数据</el-checkbox>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </fieldset>
          <fieldset style="border:1px solid #ccc;">
            <legend>合肥路政设置</legend>
            <el-form :model="curRoadInfo"
                     :inline="true"
                     label-width="150px">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="场库编号::">
                    <el-input v-model="curRoadInfo.p12510"
                              :disabled="!curRowInfo.isEdit"
                              style="width:500px">
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="余位上报地址::">
                    <el-input v-model="curRoadInfo.p12520"
                              :disabled="!curRowInfo.isEdit"
                              style="width:500px">
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </fieldset>
          <fieldset style="border:1px solid #ccc;">
            <legend>山西环保数据推送</legend>
            <el-form :model="curRoadInfo"
                     :inline="true"
                     label-width="150px">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="完整接口地址::">
                    <el-input v-model="curRoadInfo.p12801"
                              :disabled="!curRowInfo.isEdit"
                              style="width:500px">
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="企业ID::">
                    <el-input v-model="curRoadInfo.p12802"
                              :disabled="!curRowInfo.isEdit"
                              style="width:500px">
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="企业名称::">
                    <el-input v-model="curRoadInfo.p12803"
                              :disabled="!curRowInfo.isEdit"
                              style="width:500px">
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </fieldset>
          <fieldset style="border:1px solid #ccc;height:180px">
            <legend>云端二次识别</legend>
            <el-form :model="curRoadInfo"
                     :inline="true"
                     label-width="180px">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="臻识相机识别可信度低于::">
                    <el-input v-model="curRoadInfo.p10473"
                              :disabled="!curRowInfo.isEdit"
                              style="width:200px">
                    </el-input>
                    启用云端二次识别
                  </el-form-item>
                </el-col>
                <el-col :span="24"
                        style="margin-top:5px;">
                  <el-form-item label="华夏相机识别可信度低于::">
                    <el-input v-model="curRoadInfo.p10474"
                              :disabled="!curRowInfo.isEdit"
                              style="width:200px">
                    </el-input>
                    启用云端二次识别
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="参数说明："
                                class="tip_item">0为不启用云端识别<br />臻识相机取值范围1-100<br />华夏相机取值范围101-2800</el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </fieldset>
          <fieldset style="border:1px solid #ccc;">
            <legend>车辆离场调用车位引导系统地址</legend>
            <el-form :model="parkSetting"
                     :inline="true"
                     label-width="150px">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="车位引导系统地址::">
                    <el-input v-model="parkSetting.p10478"
                              :disabled="!curRowInfo.isEdit"
                              style="width:500px">
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </fieldset>
        </el-tab-pane>
        <el-tab-pane label="路政设置"
                     name="editRoadInfo">
          <fieldset>
            <legend style="padding-top: 10px">上海路政设置</legend>
            <el-form :model="curRoadInfo"
                     :inline="true"
                     label-width="120px">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="数据上传IP地址::">
                    <el-input v-model="curRoadInfo.p12010"
                              :disabled="!curRowInfo.isEdit"
                              class="myParkInput">
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="端口号::">
                    <el-input v-model="curRoadInfo.p12020"
                              :disabled="!curRowInfo.isEdit"
                              class="myParkInput"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="终端序列号::">
                    <el-input v-model="curRoadInfo.p12030"
                              :disabled="!curRowInfo.isEdit"
                              class="myParkInput"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="SIM卡编号::">
                    <el-input v-model="curRoadInfo.p12040"
                              :disabled="!curRowInfo.isEdit"
                              class="myParkInput"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="PSAM卡号::">
                    <el-input v-model="curRoadInfo.p12050"
                              :disabled="!curRowInfo.isEdit"
                              class="myParkInput"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="停车点编号::">
                    <el-input v-model="curRoadInfo.p12060"
                              :disabled="!curRowInfo.isEdit"
                              class="myParkInput"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="平台编号::">
                    <el-input v-model="curRoadInfo.p12070"
                              :disabled="!curRowInfo.isEdit"
                              class="myParkInput"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="服务时间::">
                    <el-input v-model="curRoadInfo.p12080"
                              :disabled="!curRowInfo.isEdit"
                              class="myParkInput"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="收费标准::">
                    <el-input v-model="curRoadInfo.p12090"
                              :disabled="!curRowInfo.isEdit"
                              class="myParkInput"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </fieldset>
          <fieldset>
            <legend>市中检查设置</legend>
            <el-form :model="curRoadInfo"
                     :inline="true"
                     label-width="120px">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="通讯IP地址::">
                    <el-input v-model="curRoadInfo.p12110"
                              :disabled="!curRowInfo.isEdit"
                              class="myParkInput"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="端口号::">
                    <el-input v-model="curRoadInfo.p12120"
                              :disabled="!curRowInfo.isEdit"
                              class="myParkInput"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="厂商编码::">
                    <el-input v-model="curRoadInfo.p12130"
                              :disabled="!curRowInfo.isEdit"
                              class="myParkInput"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="地址编码::">
                    <el-input v-model="curRoadInfo.p12140"
                              :disabled="!curRowInfo.isEdit"
                              class="myParkInput"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="接收方地址::">
                    <el-input v-model="curRoadInfo.p12150"
                              :disabled="!curRowInfo.isEdit"
                              class="myParkInput"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </fieldset>
          <fieldset>
            <legend>公交卡设置</legend>
            <el-form :model="curRoadInfo"
                     :inline="true"
                     label-width="120px">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="COM端口号::">
                    <el-select v-model="curRoadInfo.p12160"
                               placeholder="请选择"
                               :disabled="!curRowInfo.isEdit"
                               class="myParkInput">
                      <el-option v-for="item in commList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="MySQL IP地址::">
                    <el-input v-model="curRoadInfo.p12200"
                              :disabled="!curRowInfo.isEdit"
                              class="myParkInput"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="停车场用户代码::">
                    <el-input v-model="curRoadInfo.p12170"
                              :disabled="!curRowInfo.isEdit"
                              class="myParkInput"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="MySQL 登录名::">
                    <el-input v-model="curRoadInfo.p12210"
                              :disabled="!curRowInfo.isEdit"
                              class="myParkInput"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="设备编码::">
                    <el-input v-model="curRoadInfo.p12180"
                              :disabled="!curRowInfo.isEdit"
                              class="myParkInput"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="MySQL密码::">
                    <el-input v-model="curRoadInfo.p12220"
                              :disabled="!curRowInfo.isEdit"
                              class="myParkInput"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="营运单位代码::">
                    <el-input v-model="curRoadInfo.p12190"
                              :disabled="!curRowInfo.isEdit"
                              class="myParkInput"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="数据库名::">
                    <el-input v-model="curRoadInfo.p12230"
                              :disabled="!curRowInfo.isEdit"
                              class="myParkInput"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row class="trans_row">
                <el-col :span="12">
                  <el-form-item label="数据传输方式::">
                    <el-select v-model="curRoadInfo.p12100"
                               placeholder="请选择"
                               :disabled="!curRowInfo.isEdit"
                               class="myParkInput">
                      <el-option v-for="item in parkSHRATransTypeList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </fieldset>
        </el-tab-pane>
        <el-tab-pane label="上海路政2019"
                     name="editRoadInfo_2019">
          <fieldset>
            <legend style="padding-top: 10px">上海路政设置</legend>
            <el-form :model="curRoadInfo"
                     :inline="true"
                     label-width="180px">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="数据上传IP地址(ServerIP)::">
                    <el-input v-model="curRoadInfo.p12240"
                              :disabled="!curRowInfo.isEdit"
                              class="myParkInput">
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="端口号(ServerPort)::">
                    <el-input v-model="curRoadInfo.p12250"
                              :disabled="!curRowInfo.isEdit"
                              class="myParkInput"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="场库标识(ParkingId)::">
                    <el-input v-model="curRoadInfo.p12260"
                              :disabled="!curRowInfo.isEdit"
                              class="myParkInput"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="上报路政车位数::">
                    <el-input v-model="curRoadInfo.p12281"
                              :disabled="!curRowInfo.isEdit"
                              class="myParkInput"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="接入账号(AppId)::">
                    <el-input v-model="curRoadInfo.p12270"
                              :disabled="!curRowInfo.isEdit"
                              class="myParkInput"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="接入密码(Password)::">
                    <el-input v-model="curRoadInfo.p12280"
                              :disabled="!curRowInfo.isEdit"
                              class="myParkInput"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="传输方式::">
                    <el-select v-model="curRoadInfo.p12290"
                               placeholder="请选择"
                               :disabled="!curRowInfo.isEdit"
                               class="myParkInput">
                      <el-option v-for="item in parkSHRATrans2019TypeList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="在场车辆统计天数::">
                    <el-select v-model="curRoadInfo.p12314"
                               placeholder="请选择"
                               :disabled="!curRowInfo.isEdit"
                               class="myParkInput">
                      <el-option v-for="item in shra2019RecDaysList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label=" ">
                    <el-checkbox v-model="curRoadInfo.p12312"
                                 :disabled="!curRowInfo.isEdit">不上传月卡车进出数据</el-checkbox>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label=" ">
                    <el-checkbox v-model="curRoadInfo.p12311"
                                 :disabled="!curRowInfo.isEdit">不上传临时车进出数据</el-checkbox>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="检测车牌号码::">
                    <el-input v-model="curRoadInfo.p12313"
                              :disabled="!curRowInfo.isEdit"
                              class="myParkInput"></el-input><span>&nbsp;&nbsp;单独记录该车牌的路政上传日志，方便数据核对。</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <legend style="padding-top: 10px">上海临港路政心跳设置 </legend>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="数据上传IP地址(ServerIP)::">
                    <el-input v-model="curRoadInfo.p12291"
                              :disabled="!curRowInfo.isEdit"
                              class="myParkInput"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="端口号(ServerPort)::">
                    <el-input v-model="curRoadInfo.p12292"
                              :disabled="!curRowInfo.isEdit"
                              class="myParkInput"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="场库标识(ParkingId)::">
                    <el-input v-model="curRoadInfo.p12293"
                              :disabled="!curRowInfo.isEdit"
                              class="myParkInput"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="上报路政车位数::">
                    <el-input v-model="curRoadInfo.p12296"
                              :disabled="!curRowInfo.isEdit"
                              class="myParkInput"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="接入账号(AppId)::">
                    <el-input v-model="curRoadInfo.p12294"
                              :disabled="!curRowInfo.isEdit"
                              class="myParkInput"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="接入密码(Password)::">
                    <el-input v-model="curRoadInfo.p12295"
                              :disabled="!curRowInfo.isEdit"
                              class="myParkInput"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <legend style="padding-top: 10px">上海路政公交卡设置 </legend>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="停车场用户代码::">
                    <el-input v-model="curRoadInfo.p12300"
                              :disabled="!curRowInfo.isEdit"
                              class="myParkInput"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="营运单位代码::">
                    <el-input v-model="curRoadInfo.p12310"
                              :disabled="!curRowInfo.isEdit"
                              class="myParkInput"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8" style="margin-left:180px">
                  <el-form-item label="">
                      <el-checkbox v-model="curRoadInfo.p12315"
                      @change="onChange"
                                  :disabled="!curRowInfo.isEdit">铁路模式</el-checkbox>
                  </el-form-item>
                </el-col>
                <el-col :span="8" style="margin-left:75px">
                  <el-form-item label="">
                      <el-checkbox v-model="curRoadInfo.p12316"
                      @change="onChange"
                                  :disabled="!curRowInfo.isEdit">延长封顶时段（5:00-23:59）</el-checkbox>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </fieldset>
        </el-tab-pane>
        <el-tab-pane label="上海智慧停车"
                     name="editSmartPark">
          <el-form :model="curRoadInfo"
                   :inline="true"
                   label-width="180px"
                   style="margin-top:10px;">
            <el-row>
              <el-col :span="12">
                <el-form-item label="预约车费率组【小型车】::">
                  <el-select v-model="curRoadInfo.p10530"
                             placeholder="请选择"
                             style="width:160px"
                             :disabled="!curRowInfo.isEdit">
                    <el-option v-for="item in rateSelectList"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="预约金额【小型车】::">
                  <el-input v-model="curRoadInfo.p10540"
                            style="width:160px"
                            :disabled="!curRowInfo.isEdit"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="预约车费率组【大型车】::">
                  <el-select v-model="curRoadInfo.p10510"
                             placeholder="请选择"
                             style="width:160px"
                             :disabled="!curRowInfo.isEdit">
                    <el-option v-for="item in rateSelectList"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="预约金额【大型车】::">
                  <el-input v-model="curRoadInfo.p10520"
                            style="width:160px"
                            :disabled="!curRowInfo.isEdit"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="错峰车费率组::">
                  <el-select v-model="curRoadInfo.p10550"
                             placeholder="请选择"
                             style="width:160px"
                             :disabled="!curRowInfo.isEdit">
                    <el-option v-for="item in rateSelectList"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="北京路政"
                     name="editBJRoad">
          <el-form :model="curRoadInfo"
                   :inline="true"
                   label-width="180px">
            <el-row>
              <el-col :span="12">
                <el-form-item label="接口地址::">
                  <el-input v-model="curRoadInfo.p12708"
                            :disabled="!curRowInfo.isEdit"
                            class="myParkInput">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="应用ID(AppId)::">
                  <el-input v-model="curRoadInfo.p12709"
                            :disabled="!curRowInfo.isEdit"
                            class="myParkInput"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="应用密钥(Secret)::">
                  <el-input v-model="curRoadInfo.p12710"
                            :disabled="!curRowInfo.isEdit"
                            class="myParkInput"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="设备商编码::">
                  <el-input v-model="curRoadInfo.p12711"
                            :disabled="!curRowInfo.isEdit"
                            class="myParkInput"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="邮政编码::">
                  <el-input v-model="curRoadInfo.p12701"
                            :disabled="!curRowInfo.isEdit"
                            class="myParkInput"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="停车场统一编码::">
                  <el-input v-model="curRoadInfo.p12702"
                            :disabled="!curRowInfo.isEdit"
                            class="myParkInput"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="停车场序列号::">
                  <el-input v-model="curRoadInfo.p12703"
                            :disabled="!curRowInfo.isEdit"
                            class="myParkInput"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="停车场登记名称::">
                  <el-input v-model="curRoadInfo.p12704"
                            :disabled="!curRowInfo.isEdit"
                            class="myParkInput"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="停车场运营单位::">
                  <el-input v-model="curRoadInfo.p12705"
                            :disabled="!curRowInfo.isEdit"
                            class="myParkInput"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="停车场性质::">
                  <el-select v-model="curRoadInfo.p12706"
                             placeholder="请选择"
                             :disabled="!curRowInfo.isEdit"
                             class="myParkInput">
                    <el-option v-for="item in bjcyPropertyList"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="停车场类型::">
                  <el-select v-model="curRoadInfo.p12707"
                             placeholder="请选择"
                             :disabled="!curRowInfo.isEdit"
                             class="myParkInput">
                    <el-option v-for="item in bjcyTypeList"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-tab-pane>
      </el-tabs>
      <el-row style="margin-top:-1px">
        <el-col :span="12">
          <div class="tab_foot">&nbsp;</div>
        </el-col>
        <el-col :span="12">
          <div class="dialog-footer">
            <el-button type="primary"
                       @click="submitForm('form')"
                       v-if="curRowInfo.isEdit"
                       :loading="save_loading">{{save_msg}}</el-button>
            <el-button @click="parkEditOrDetailVisible = false">取消</el-button>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import * as park from '../api/park'
import * as rate from '../api/rate'
import $ from 'jquery'
import AMapLoader from '@amap/amap-jsapi-loader'
export default {
  name: 'parkView',
  data () {
    return {
      marker: '',
      form: { lng: '', lat: '', address: '', adcode: '' },
      map: null,
      auto: null,
      userInput: '',
      placeSearch: null,
      searchHere: [],
      save_loading: false,
      save_msg: '保存',
      map_search_list: [],
      IPAddr: '',
      IPPort: '',
      autoDelDataList: [],
      autoDelDataDefaultValue: '',
      mulCarList: [],
      mulCarDefaultValue: '',
      carOuterList: [],
      carOuterLists: [],
      carOuterDefaultValue: '',
      carOuterDefaultValues: '',
      tmpCarEnterList: [],
      tmpCarEnterDefaultValue: '',
      parkPicSaveList: [],
      parkPicSaveDefaultValue: '',
      rateSelectList: [{ text: '无', value: '0' }],
      parkFullTmpMgrList: [],
      parkFullTmpMgrDefaultValue: '',
      parkFullMonMgrList: [],
      parkFullMonMgrDefaultValue: '',
      parkFullGreenMgrList: [],
      parkFullGreenMgrDefaultValue: '',
      parkNoInDataList: [],
      parkNoInDataDefaultValue: '',
      parkPassWorkTypeList: [],
      parkPassWorkTypeDefaultValue: '',
      parkSHRATransTypeList: [],
      parkSHRATransTypeDefaultValue: '',
      parkSHRATrans2019TypeList: [],
      parkSHRATrans2019TypeDefaultValue: '',
      tmpTimeOutInTypeList: [],
      tmpTimeOutInTypeDefaultValue: '',
      tmpInDelayTimeList: [],
      tmpInDelayTimeDefaultValue: '',
      shra2019RecDaysList: [],
      shra2019RecDaysDefaultValue: '',
      bjcyPropertyList: [],
      bjcyPropertyDefaultValue: '',
      bjcyTypeList: [],
      bjcyTypeDefaultValue: '',
      commList: [],
      tmpCarInTimeList: [],
      // regTypeList: [{ text: '公司代理', value: '0' }, { text: '用户注册', value: '1' }],
      parkSetting: {
        p10010: '0',
        p10011: '0',
        p10012: '0',
        p10020: '0',
        p10021: '0',
        p10022: '0',
        p10023: '0',
        p10025: '0',
        p10026: '0',
        p10027: '0',
        p10028: '0',
        p10029: '0',
        p10031: '0',
        p10024: '0',
        p10170: '',
        p10140: '',
        p10100: '',
        p10030: 0,
        p10420: 100,
        p10430: 100,
        p10431: 0,
        p14032: 0,
        p10040: false,
        p10050: 0,
        p10060: false,
        p10070: 0,
        p10071: 0,
        p10080: false,
        p10190: false,
        p10090: false,
        p10091: false,
        p10092: false,
        p10093: false,
        p10372: false,
        p10373: false,
        p10110: '',
        p10150: '',
        p10390: '',
        p10160: '',
        p10180: '',
        p10230: '',
        p10105: '',
        p10250: '',
        p10260: '',
        p10270: '',
        p10280: '',
        p10290: false,
        p10106: '',
        p10107: '',
        p10210: false,
        p10240: false,
        p10440: false,
        p10450: false,
        p10470: false,
        p10220: '',
        p10200: '',
        p10112: '',
        p10111: '',
        p10340: false,
        p10300: false,
        p10460: false,
        p10350: '',
        p10360: '',
        p10361: '',
        p10370: '',
        p10478: '',
        p10471: '30',
        p10475: '',
        p10476: '',
        p10477: 99999
      },
      curRoadInfo: {
        p10510: '0',
        p10520: '',
        p10530: '0',
        p10540: '',
        p10550: '0',
        p12010: '',
        p12020: '',
        p12030: '',
        p12040: '',
        p12050: '',
        p12060: '',
        p12070: '',
        p12080: '',
        p12090: '',
        p12110: '',
        p12120: '',
        p12130: '',
        p12140: '',
        p12150: '',
        p12160: '',
        p12200: '',
        p12170: '',
        p12210: '',
        p12180: '',
        p12220: '',
        p12190: '',
        p12230: '',
        p12240: '',
        p12250: '',
        p12260: '',
        p12270: '',
        p12280: '',
        p12290: '',
        p12313: '',
        p12314: '',
        P12315: false,
        P12316: false,
        p12281: '',
        p12311: false,
        p12312: false,
        p12300: '',
        p12310: '',
        p12291: '',
        p12292: '',
        p12293: '',
        p12294: '',
        p12295: '',
        p12296: '',
        p12510: '',
        p12520: '',
        p12701: '',
        p12702: '',
        p12703: '',
        p12704: '',
        p12705: '',
        p12706: '',
        p12707: '',
        p12708: '',
        p12709: '',
        p12710: '',
        p12711: '',
        p12801: '',
        p12802: '',
        p12803: '',
        p10473: '0',
        p10474: '0'
      },
      curRowInfo: {
        fBigRowID: '',
        op: '',
        isEdit: false,
        fParkID: '',
        fCompanyID: 0,
        fCustID: '',
        fCustNo: '',
        fParkNo: '',
        fParkName: '',
        fParkTypeID: '',
        fLinkman: '',
        fLinkPhone: '',
        fAddress: '',
        fParkCount: '',
        fResCount: '',
        fMapSvrID: '1',
        fLongitude: '',
        fLatitude: '',
        fHigh: '0',
        fProvinceID: 0,
        fCityID: 0,
        fDistID: 0,
        fProvName: '',
        fCityName: '',
        fDistName: '',
        fIsDel: '',
        fIsSyncData: ''
      },
      tab_height: 0,
      parkTypeList: [],
      parkTypeDefaultValue: '',
      mapList: [],
      isEdit: false,
      editOrDetail: 'editBaseInfo',
      parkEditOrDetailVisible: false,
      detailTitle: '查看停车场信息',
      activeName: 'baseInfo',
      parkDetailVisible: false
      // wechatSer: false,
      // unionPay: false,
      // wechatCom: false,
      // alipay: false,
      // unionPayStatus: false,
      // wechatSerStatus: false,
      // wechatComStatus: false,
      // alipayStatus: false
    }
  },
  props: {
    parkActiveName: String,
    choiceCusts: Array
  },
  methods: {
    onChange (event) {
      this.$forceUpdate()
      console.log(event)
    },
    address_keyup (e) {
      if ((this.curRowInfo.fAddress || '').trim().length <= 0) {
        this.map_search_list = []
        this.curRowInfo.fAddress = ''
        this.curRowInfo.fLongitude = ''
        this.curRowInfo.fLatitude = ''
        this.curRowInfo.fProvName = ''
        this.curRowInfo.fCityName = ''
        this.curRowInfo.fDistName = ''
        return false
      }
      $(this.$el).find('.search_list .el-row').removeClass('selected')
      var options = {
        onSearchComplete: (results) => {
          if (local.getStatus() === 0) {
            this.map_search_list = []
            for (var i = 0; i < results.getCurrentNumPois(); i++) {
              if (i < 6) {
                this.map_search_list.push(results.getPoi(i))
              }
            }
          }
        }
      }
      var local = new window.BMapGL.LocalSearch(this.map, options)
      local.search(this.curRowInfo.fAddress.trim())
      // var geo = new window.BMap.Geocoder()
      // geo.getPoint(this.curRowInfo.fAddress.trim(), (point) => {
      //   if (point) {
      //     geo.getLocation(point, (rs) => {
      //       var addComp = rs.addressComponents
      //       this.map.clearOverlays()
      //       var mk = new window.BMap.Marker(point)
      //       this.map.addOverlay(mk)
      //       this.map.panTo(point)
      //       this.curRowInfo.fAddress = addComp.province + addComp.city + addComp.district + addComp.street + addComp.streetNumber
      //       this.curRowInfo.fLongitude = point.lng
      //       this.curRowInfo.fLatitude = point.lat
      //       this.curRowInfo.fProvName = addComp.province
      //       this.curRowInfo.fCityName = addComp.city
      //       this.curRowInfo.fDistName = addComp.district
      //     })
      //   }
      // })
    },
    map_search_change (address, index) {
      $(this.$el).find('.search_list .el-row').removeClass('selected')
      $(this.$el).find('.search_list .el-row:eq(' + index + ')').addClass('selected')
      this.curRowInfo.fAddress = address.address || ''
      this.curRowInfo.fLongitude = address.point.lng
      this.curRowInfo.fLatitude = address.point.lat
      this.curRowInfo.fProvName = address.province || ''
      this.curRowInfo.fCityName = address.city || ''
      this.curRowInfo.fDistName = address.title
      this.map.clearOverlays()
      var mk = new window.BMapGL.Marker(address.point)
      this.map.addOverlay(mk)
      this.map.panTo(address.point)
      // var geo = new window.BMap.Geocoder()
      // geo.getLocation(address.point, (rs) => {
      //   var addComp = rs.addressComponents
      //   this.map.clearOverlays()
      //   var mk = new window.BMap.Marker(address.point)
      //   this.map.addOverlay(mk)
      //   this.map.panTo(address.point)
      //   this.curRowInfo.fAddress = addComp.province + addComp.city + addComp.district + addComp.street + addComp.streetNumber
      //   this.curRowInfo.fLongitude = address.point.lng
      //   this.curRowInfo.fLatitude = address.point.lat
      //   this.curRowInfo.fProvName = addComp.province
      //   this.curRowInfo.fCityName = addComp.city
      //   this.curRowInfo.fDistName = addComp.district
      // })
      // this.curRowInfo.fAddress = address.address
      // this.curRowInfo.fLongitude = address.point.lng
      // this.curRowInfo.fLatitude = address.point.lat
      // this.curRowInfo.fProvName = address.province || ''
      // this.curRowInfo.fCityName = address.city
      // this.curRowInfo.fDistName = address.district

      // this.map.clearOverlays()
      // this.map.centerAndZoom(address.point, 16)
      // this.map.addOverlay(new window.BMap.Marker(address.point))
    },
    submitForm (formName) {
      if ((this.curRowInfo.fCustID || '').trim().length <= 0) {
        this.$message.error('请先选择客户')
        return false
      }
      // let tmpCust = this.choiceCusts.filter(item => {
      //   if (item.fCustID === this.curRowInfo.fCustID) { return item }
      // })
      // if ((tmpCust || []).length <= 0) {
      //   this.$message.error('选择的客户不存在')
      //   return false
      // }
      // this.curRowInfo.fCustNo = tmpCust[0].fCustNo
      let param = {}
      param.curRowInfo = this.curRowInfo
      // param.curRowInfo.fIsDel = 0
      param.parkSetting = this.parkSetting
      param.curRoadInfo = this.curRoadInfo
      this.save_loading = true
      this.save_msg = '保存中...'
      park.savePark(param).then(res => {
        this.save_loading = false
        this.save_msg = '保存'
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.$parent.initData()
              this.parkEditOrDetailVisible = false
              this.$message({
                type: 'success',
                message: data.Msg
              })
            } else {
              this.$message.error(data.Msg)
            }
          }
        }
      })
    },
    custChange (selValue) {
      let param = {}
      param.fCustID = selValue
      this.parkSetting.p10010 = '0'
      this.parkSetting.p10011 = '0'
      this.parkSetting.p10012 = '0'
      this.parkSetting.p10020 = '0'
      this.parkSetting.p10021 = '0'
      this.parkSetting.p10022 = '0'
      this.parkSetting.p10024 = '0'
      this.parkSetting.p10023 = '0'
      this.parkSetting.p10025 = '0'
      this.parkSetting.p10026 = '0'
      this.parkSetting.p10027 = '0'
      this.parkSetting.p10028 = '0'
      this.parkSetting.p10029 = '0'
      this.parkSetting.p10031 = '0'
      this.rateSelectList = [{ text: '无', value: '0' }]
      rate.getRateGroupByCustId(param).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              let tmprateSelectList = []
              Object.assign(tmprateSelectList, data.Data)
              tmprateSelectList.forEach((value, index) => {
                this.rateSelectList.push(value)
              })
            }
          }
        }
      })
    },
    setDefault () {
      for (let key in this.curRowInfo) {
        this.curRowInfo[key] = ''
      }
      for (let key in this.RJInvoiceObject) {
        this.RJInvoiceObject[key] = ''
      }

      this.curRowInfo.fProvinceID = 0
      this.curRowInfo.fCityID = 0
      this.curRowInfo.fDistID = 0
      this.curRowInfo.fCompanyID = 0
      this.curRowInfo.isEdit = false
      this.curRowInfo.fMapSvrID = '1'
      for (let key in this.parkSetting) {
        this.parkSetting[key] = ''
      }
      for (let key in this.curRoadInfo) {
        this.curRoadInfo[key] = ''
      }
      this.rateSelectList = [{ text: '无', value: '0' }]

      this.parkSetting.p10050 = 0
      this.parkSetting.p10070 = 0
      this.parkSetting.p10071 = 0
      this.parkSetting.p10111 = this.tmpTimeOutInTypeDefaultValue
      this.parkSetting.p10112 = this.tmpInDelayTimeDefaultValue
      this.parkSetting.p10372 = false
      this.parkSetting.p10373 = false
    },
    tab_click (tab) {
      this.setTabHeight($('#' + tab.$el.id).height())
    },
    setTabHeight (contentHeight) {
      var height = $('.myParkEditOrDetail .el-tabs__content').height()
      if (this.tab_height <= 0) {
        this.tab_height = $('.myParkEditOrDetail .el-tabs__nav-scroll').height()
      }
      if (contentHeight) {
        $('.myParkEditOrDetail .el-tabs__nav-scroll').css('height', (this.tab_height > contentHeight ? this.tab_height : contentHeight) + 'px')
      } else {
        $('.myParkEditOrDetail .el-tabs__nav-scroll').css('height', (height > this.tab_height ? height : this.tab_height) + 'px')
      }
    },
    addSyncPark () {
      this.setDefault()
      this.parkEditOrDetailVisible = true
      setTimeout(() => {
        this.setTabHeight()
      }, 100)
      this.curRowInfo.op = 'add'
      this.curRowInfo.isEdit = true
      this.editOrDetail = 'editBaseInfo'
      this.detailTitle = '新增停车场'
      this.curRowInfo.fParkTypeID = this.parkTypeDefaultValue
      this.curRowInfo.fResCount = 0
      this.parkSetting.p10030 = 0
      this.parkSetting.p10420 = 100
      this.parkSetting.p10430 = 100
      this.parkSetting.p10431 = 0
      this.parkSetting.p14032 = 0
      this.parkSetting.p10170 = this.parkPicSaveDefaultValue
      this.parkSetting.p10105 = this.parkFullTmpMgrDefaultValue
      this.parkSetting.p10106 = this.parkFullMonMgrDefaultValue
      this.parkSetting.p10107 = this.parkFullGreenMgrDefaultValue
      this.parkSetting.p10250 = '00:00'
      this.parkSetting.p10260 = '24:00'
      this.parkSetting.p10270 = ''
      this.parkSetting.p10280 = ''
      this.parkSetting.p10092 = false
      this.parkSetting.p10290 = false
      this.parkSetting.p10040 = true
      this.parkSetting.p10060 = true
      this.parkSetting.p10080 = true
      this.parkSetting.p10190 = true
      this.parkSetting.p10050 = 0
      this.parkSetting.p10070 = 0
      this.parkSetting.p10071 = 0
      this.parkSetting.p10180 = 15
      this.parkSetting.p10090 = true
      this.parkSetting.p10091 = true
      this.parkSetting.p10093 = true
      this.parkSetting.p10372 = false
      this.parkSetting.p10373 = false
      this.parkSetting.p10240 = false
      this.parkSetting.p10440 = false
      this.parkSetting.p10450 = false
      this.parkSetting.p10470 = false
      this.parkSetting.p10010 = '0'
      this.parkSetting.p10011 = '0'
      this.parkSetting.p10012 = '0'
      this.parkSetting.p10020 = '0'
      this.parkSetting.p10021 = '0'
      this.parkSetting.p10022 = '0'
      this.parkSetting.p10023 = '0'
      this.parkSetting.p10025 = '0'
      this.parkSetting.p10024 = '0'
      this.parkSetting.p10026 = '0'
      this.parkSetting.p10027 = '0'
      this.parkSetting.p10028 = '0'
      this.parkSetting.p10029 = '0'
      this.parkSetting.p10031 = '0'
      this.parkSetting.p10220 = this.parkNoInDataDefaultValue
      this.parkSetting.p10200 = this.parkPassWorkTypeDefaultValue
      this.parkSetting.p10110 = this.tmpCarEnterDefaultValue
      this.parkSetting.p10390 = this.carOuterDefaultValues
      this.parkSetting.p10150 = this.carOuterDefaultValue
      this.parkSetting.p10160 = this.mulCarDefaultValue
      this.curRoadInfo.p10530 = '0'
      this.curRoadInfo.p10510 = '0'
      this.curRoadInfo.p10550 = '0'
      this.curRoadInfo.p12311 = false
      this.curRoadInfo.p12312 = false
      this.curRoadInfo.p12010 = this.IPAddr
      this.curRoadInfo.p12020 = this.IPPort
      this.curRoadInfo.p12100 = this.parkSHRATransTypeDefaultValue
      this.curRoadInfo.p12290 = this.parkSHRATrans2019TypeDefaultValue
      this.curRoadInfo.p12314 = this.shra2019RecDaysDefaultValue
      this.curRoadInfo.p12315 = false
      this.curRoadInfo.p12316 = false
      this.parkSetting.p10112 = this.tmpInDelayTimeDefaultValue
      this.parkSetting.p10111 = this.tmpTimeOutInTypeDefaultValue
      this.parkSetting.p10350 = this.autoDelDataDefaultValue
      this.curRoadInfo.p12706 = this.bjcyPropertyDefaultValue
      this.curRoadInfo.p12707 = this.bjcyTypeDefaultValue
      this.curRoadInfo.p10473 = '0'
      this.curRoadInfo.p10474 = '0'
      this.parkSetting.p10471 = '30'
      this.parkSetting.p10475 = ''
      this.parkSetting.p10476 = ''
      this.parkSetting.p10477 = 99999
      this.map_search_list = []
      this.$nextTick(() => {
        // this.createBaiduMap()
        this.initMap()
      })
    },
    updatePark (row, isEdit, op) {
      this.setDefault()
      let curRow = {}
      Object.assign(curRow, row)
      this.curRowInfo = curRow
      this.curRowInfo.isEdit = isEdit
      this.curRowInfo.op = op
      this.curRowInfo.fIsSyn = this.parkActiveName === 'synParkList'
      this.detailTitle = '【' + row.fCustName + '(' + row.fCustNo + ')' + '-' + row.fParkName + '】' + (isEdit ? '编辑场库' : '查看场库')
      row.parkActiveName = this.parkActiveName
      this.rateSelectList = [{ text: '无', value: '0' }]
      this.map_search_list = []
      this.$nextTick(() => {
        // this.createBaiduMap()
        this.initMap(row)
      })
      this.parkEditOrDetailVisible = true

      setTimeout(() => {
        this.setTabHeight()
      }, 100)
      park.getAllParkParamByParkId({ fIsPay: false, fCustID: row.fCustID, fParkID: row.fParkID, fIsSyn: this.parkActiveName === 'synParkList' }).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              let tmprateSelectList = []
              Object.assign(this.curRoadInfo, data.Data.roadInfoObject)
              Object.assign(tmprateSelectList, data.Data.rateSelectList)
              // var parkSetting = (data.Data.parkSetting || {})
              // if (parkSetting.p10010 && parkSetting.p10010 === '0') {
              //   parkSetting.p10010 = ''
              // }
              // if (parkSetting.p10020 && parkSetting.p10020 === '0') {
              //   parkSetting.p10020 = ''
              // }
              // if (parkSetting.p10021 && parkSetting.p10021 === '0') {
              //   parkSetting.p10021 = ''
              // }
              // if (parkSetting.p10022 && parkSetting.p10022 === '0') {
              //   parkSetting.p10022 = ''
              // }
              // if (parkSetting.p10023 && parkSetting.p10023 === '0') {
              //   parkSetting.p10023 = ''
              // }
              // if (parkSetting.p10024 && parkSetting.p10024 === '0') {
              //   parkSetting.p10024 = ''
              // }
              this.parkSetting.p10477 = 99999 // 编辑场库设置信息，未返回默认为0
              Object.assign(this.parkSetting, data.Data.parkSetting)
              tmprateSelectList.forEach((value, index) => {
                this.rateSelectList.push(value)
              })

              // this.unionPayStatus = data.Data.unionPayStatus
              // this.wechatSerStatus = data.Data.wechatSerStatus
              // this.wechatComStatus = data.Data.wechatComStatus
              // this.alipayStatus = data.Data.alipayStatus
            } else {
              this.$message.error(data.Msg)
            }
          }
        }
      })
    },
    viewPark (row, needQuery, fParkID) {
      this.editOrDetail = 'editBaseInfo'
      if (row && row !== null && typeof (row) !== 'undefined') {
        if (needQuery) {
          park.getParkInfo({
            fCustID: row.fCustID,
            fParkID: fParkID
          }).then(res => {
            if (res && res.data) {
              let { status, data } = res
              if (status === 200) {
                if (data.IsOk) {
                  this.updatePark(data.Data, false, 'view')
                } else {
                  this.$message.error(data.Msg)
                }
              }
            }
          })
        } else {
          this.updatePark(row, false, 'view')
        }
      }
    },
    synPark (row, isSyn) {
      if (row && row !== null && typeof (row) !== 'undefined') {
        var msg = ''
        if (isSyn) {
          msg = '从云平台下发同步到线下客户端'
        } else {
          msg = '从线下客户端上传同步到云平台'
        }
        this.$confirm('将客户[' + row.fCustName + ']的场库[' + row.fParkName + ']' + msg + ', 是否继续?', '提示', {
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          type: 'warning'
        }).then(() => {
          park.synParkById({
            fBigRowID: row.fBigRowID,
            fIsSyn: isSyn,
            fIsPay: false
          }).then(res => {
            if (res && res.data) {
              let { status, data } = res
              if (status === 200) {
                if (data.IsOk) {
                  this.$message({
                    type: 'success',
                    message: '操作完成'
                  })
                  this.$parent.initData()
                } else {
                  this.$message.error(data.Msg)
                }
              }
            }
          })
        }).catch(() => { })
      }
    },
    editParkClient (row) {
      this.editOrDetail = 'editBaseInfo'
      if (row && row !== null && typeof (row) !== 'undefined') {
        this.updatePark(row, true, 'edit')
      }
    },
    deleteParkClient (row) {
      this.$confirm('删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        park.deletePark({ fBigRowID: row.fBigRowID, fIsSyn: this.parkActiveName === 'synParkList', fIsPay: false }).then(res => {
          if (res && res.data) {
            let { status, data } = res
            if (status === 200) {
              if (data.IsOk) {
                this.$message({
                  type: 'success',
                  message: data.Msg
                })
                this.$parent.initData()
              } else {
                this.$message.error(data.Msg)
              }
            }
          }
        })
      })
    },
    initMap (row) {
      AMapLoader.load({ key: '27b507823bebca4fe6647fcebdeb9f01', version: '2.0', plugins: ['AMap.ToolBar', 'AMap.Marker', 'AMap.Scale', 'AMap.HawkEye', 'AMap.MapType', 'AMap.Geolocation', 'AMap.AutoComplete', 'AMap.PlaceSearch', 'AMap.Geocoder']
      }).then((AMap) => {
        let location = {}
        if (row) {
          // {lng:row.fLongitude,lat:row.fLatitude}
          location = [row.fLongitude, row.fLatitude]
          // console.log('后台返回的地址', location)
          this.curRowInfo.fLatitude = row.fLatitude
          this.curRowInfo.fLongitude = row.fLongitude
          if (row.fLongitude === 0 || row.fLatitude === 0 || row.fLongitude === '' || row.fLatitude === '') {
            location = [116.331398, 39.897445]
          }
        } else {
          location = [116.331398, 39.897445]
        }
        this.map = new AMap.Map('parkBaiduMap', { zoom: 13, center: location })
        this.map.on('click', (e) => {
          // this.curRowInfo.fAddress = e.data.address
          this.curRowInfo.fLatitude = e.lnglat.kT
          this.curRowInfo.fLongitude = e.lnglat.KL
          // 获取经纬度
          this.form.lng = e.lnglat.KL
          this.form.lat = e.lnglat.kT
          // 清除点
          this.removeMarker()
          // 标记点
          this.setMapMarker(e)
        })
        this.map.addControl(new AMap.Scale())
        this.map.addControl(new AMap.Marker())
        this.map.addControl(new AMap.ToolBar())
        this.map.addControl(new AMap.HawkEye())
        this.map.addControl(new AMap.MapType())
        this.map.addControl(new AMap.Geolocation())
        var autoOptions = { input: 'mapInput' }
        this.auto = new AMap.AutoComplete(autoOptions)
        this.placeSearch = new AMap.PlaceSearch({ map: this.map })
        // console.log(this.selectResult)
        this.auto.on('select', this.selectResult)
        AMap.Event.addListener(this.placeSearch, 'markerClick', function (e) {
          // console.log(e.data.location)// 当前marker的经纬度信息
          this.curRowInfo.fAddress = e.data.address
          this.curRowInfo.fLatitude = e.lnglat.kT
          this.curRowInfo.fLongitude = e.lnglat.KL
          // document.getElementById("lnglat").value = e.data.location.lng + ',' + e.data.location.lat
          // console.log(e.data.address)// 获取当前marker的具体地址信息
          // console.log(e.data)// 则是包含所有的marker数据
          // document.getElementById("input").value =  e.data.address;
        })
        // 如果有数据 就显示
        if (row) {
          this.marker = new AMap.Marker({ map: this.map, position: location })
          this.map.add(this.marker)
        }
      }).catch((e) => { console.log(e) })
    },
    setMapMarker (e) {
      // 自动适应显示想显示的范围区域
      const { lng, lat } = e.lnglat
      // 获取位置信息
      var geocoder = new window.AMap.Geocoder({ radius: 1000 })
      geocoder.getAddress(e.lnglat, (status, result) => {
        if (status === 'complete' && result.regeocode) {
          var address = result.regeocode.formattedAddress
          // console.log(address)
          this.curRowInfo.fAddress = address
        } else {
          console.error('根据经纬度查询地址失败')
        }
      })
      // this.map.setFitView()
      this.marker = new window.AMap.Marker({ map: this.map, position: [lng, lat] })
      this.map.add(this.marker)
      // this.map.setFitView()
    },
    // 清除点
    removeMarker () {
      if (this.marker) {
        this.map.remove(this.marker)
      }
    },
    selectResult (e) {
      this.placeSearch.setCity(e.poi.adcode) // 依据城市ID搜索
      this.placeSearch.search(e.poi.name) // 关键字查询查询
      this.map.setZoom(10, true)
      this.searchHere = e.poi
      this.$message({ message: '选择地点:' + this.searchHere.name, type: 'success' })
    },
    createBaiduMap () {
      this.map = new window.BMapGL.Map('parkBaiduMap')// 显示标签
      var point = new window.BMapGL.Point(116.331398, 39.897445)
      this.map.centerAndZoom(point, 16)
      this.map.enableScrollWheelZoom(true)
      var geoc = new window.BMapGL.Geocoder()
      this.map.addControl(new window.BMapGL.NavigationControl())
      this.map.enableAutoResize()
      if (this.curRowInfo.fLongitude > 0 && this.curRowInfo.fLatitude > 0) {
        this.map.clearOverlays()
        var newPoint = new window.BMapGL.Point(this.curRowInfo.fLongitude, this.curRowInfo.fLatitude)
        var marker = new window.BMapGL.Marker(newPoint)
        this.map.addOverlay(marker)
        this.map.panTo(newPoint)
      }

      this.map.addEventListener('click', (e) => {
        $(this.$el).find('.search_list .el-row').removeClass('selected')
        this.map_search_list = []
        var pt = new window.BMapGL.Point(e.latlng.lng, e.latlng.lat)
        geoc.getLocation(pt, (rs) => {
          var addComp = rs.addressComponents
          this.map.clearOverlays()
          var mk = new window.BMapGL.Marker(pt)
          this.map.addOverlay(mk)
          this.map.panTo(pt)
          this.curRowInfo.fAddress = rs.address || ''
          this.curRowInfo.fLongitude = pt.lng
          this.curRowInfo.fLatitude = pt.lat
          this.curRowInfo.fProvName = addComp.province
          this.curRowInfo.fCityName = addComp.city
          this.curRowInfo.fDistName = addComp.district
        })
      })
    }
  },
  created () {

  },
  computed: {

  },
  watch: {
    'parkSetting.p10023' (newValue, oldValue) {
      if (this.parkSetting.p10023 !== '0') {
        this.parkSetting.p10240 = false
      }
    },
    'parkSetting.p10025' (newValue, oldValue) {
      if (this.parkSetting.p10025 !== '0') {
        this.parkSetting.p10240 = false
      }
    },
    'parkSetting.p10240' (newValue, oldValue) {
      if (this.parkSetting.p10240) {
        this.parkSetting.p10023 = '0'
        this.parkSetting.p10025 = '0'
      }
    }
  },
  mounted () {
    park.getMapAndParkType({}).then(res => {
      if (res && res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            let mapList = []
            let parkTypeList = {}
            let commList = []
            let mulCarList = []
            let carOuterList = []
            let carOuterLists = []
            let tmpCarEnterList = []
            let parkPicSaveList = []
            let parkFullTmpMgrList = []
            let parkFullMonMgrList = []
            let parkFullGreenMgrList = []
            let parkNoInDataList = []
            let parkPassWorkTypeList = []
            let parkSHRATransTypeList = []
            let parkSHRATrans2019TypeList = []
            let tmpTimeOutInTypeList = []
            let tmpInDelayTimeList = []
            let autoDelDataList = []
            let shra2019RecDaysList = []
            Object.assign(mapList, data.Data.mapType)
            Object.assign(parkTypeList, data.Data.parkType)
            Object.assign(commList, data.Data.commList)
            Object.assign(parkPicSaveList, data.Data.parkPicSaveList)
            Object.assign(tmpCarEnterList, data.Data.tmpCarEnterList)
            Object.assign(carOuterList, data.Data.carOuterList)
            Object.assign(carOuterLists, data.Data.carOuterLists)
            Object.assign(mulCarList, data.Data.mulCarList)
            Object.assign(parkFullTmpMgrList, data.Data.parkFullTmpMgrList)
            Object.assign(parkFullMonMgrList, data.Data.parkFullMonMgrList)
            Object.assign(parkFullGreenMgrList, data.Data.parkFullGreenMgrList)
            Object.assign(parkNoInDataList, data.Data.parkNoInDataList)
            Object.assign(parkPassWorkTypeList, data.Data.parkPassWorkTypeList)
            Object.assign(parkSHRATransTypeList, data.Data.parkSHRATransTypeList)
            Object.assign(parkSHRATrans2019TypeList, data.Data.parkSHRATrans2019TypeList)
            Object.assign(tmpTimeOutInTypeList, data.Data.tmpTimeOutInTypeList)
            Object.assign(tmpInDelayTimeList, data.Data.tmpInDelayTimeList)
            Object.assign(autoDelDataList, data.Data.autoDelDataList)
            Object.assign(shra2019RecDaysList, data.Data.shra2019RecDaysList)
            this.mulCarList = mulCarList
            this.mulCarDefaultValue = data.Data.mulCarDefaultValue
            this.carOuterList = carOuterList
            this.carOuterLists = carOuterLists
            this.carOuterDefaultValue = data.Data.carOuterDefaultValue
            this.carOuterDefaultValues = data.Data.carOuterDefaultValues
            this.tmpCarEnterList = tmpCarEnterList
            this.tmpCarEnterDefaultValue = data.Data.tmpCarEnterDefaultValue
            this.parkPicSaveList = parkPicSaveList
            this.autoDelDataList = autoDelDataList
            this.parkPicSaveDefaultValue = data.Data.parkPicSaveDefaultValue
            this.commList = commList
            this.mapList = mapList
            this.parkTypeList = parkTypeList
            this.parkTypeDefaultValue = data.Data.parkTypeDefaultValue
            this.parkFullTmpMgrList = parkFullTmpMgrList
            this.parkFullTmpMgrDefaultValue = data.Data.parkFullTmpMgrDefaultValue
            this.parkFullMonMgrList = parkFullMonMgrList
            this.parkFullMonMgrDefaultValue = data.Data.parkFullMonMgrDefaultValue
            this.parkFullGreenMgrList = parkFullGreenMgrList
            this.parkFullGreenMgrDefaultValue = data.Data.parkFullGreenMgrDefaultValue
            this.parkNoInDataList = parkNoInDataList
            this.parkNoInDataDefaultValue = data.Data.parkNoInDataDefaultValue
            this.parkPassWorkTypeList = parkPassWorkTypeList
            this.parkPassWorkTypeDefaultValue = data.Data.parkPassWorkTypeDefaultValue
            this.parkSHRATransTypeList = parkSHRATransTypeList
            this.parkSHRATransTypeDefaultValue = data.Data.parkSHRATransTypeDefaultValue
            this.parkSHRATrans2019TypeList = parkSHRATrans2019TypeList
            this.parkSHRATrans2019TypeDefaultValue = data.Data.parkSHRATrans2019TypeDefaultValue
            this.shra2019RecDaysList = shra2019RecDaysList
            this.shra2019RecDaysDefaultValue = data.Data.shra2019RecDaysDefaultValue
            this.bjcyTypeList = data.Data.bjcyTypeList || []
            this.bjcyTypeDefaultValue = data.Data.bjcyTypeDefaultValue
            this.bjcyPropertyList = data.Data.bjcyPropertyList || []
            this.bjcyPropertyDefaultValue = data.Data.bjcyPropertyDefaultValue
            this.IPAddr = data.Data.IPAddr
            this.IPPort = data.Data.IPPort
            this.tmpTimeOutInTypeList = tmpTimeOutInTypeList
            this.tmpTimeOutInTypeDefaultValue = data.Data.tmpTimeOutInTypeDefaultValue
            this.tmpInDelayTimeList = tmpInDelayTimeList
            this.tmpInDelayTimeDefaultValue = data.Data.tmpInDelayTimeDefaultValue
            this.autoDelDataDefaultValue = data.Data.autoDelDataDefaultValue
            // let curRow = {}
            // Object.assign(curRow, row)
            // this.curRowInfo = curRow
          }
        }
      }
    })

    for (var i = 0; i < 24; i++) {
      for (var j = 0; j < 12; j++) {
        var option = (i < 10 ? '0' + i : i) + ':' + ((j * 5) < 10 ? '0' + (j * 5) : (j * 5))
        this.tmpCarInTimeList.push({ text: option, value: option })
      }
    }
    this.tmpCarInTimeList.push({ text: '24:00', value: '24:00' })
  },
  updated () {

  }
}
</script>

<style>
.myParkEditOrDetail .el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: #606266;
}
.myParkEditOrDetail
  .el-checkbox__input.is-disabled.is-checked
  .el-checkbox__inner::after {
  border-color: #000000;
}
.myParkEditOrDetail .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
.myParkEditOrDetail .el-dialog__title {
  color: white;
}
.myParkEditOrDetail .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
.myParkEditOrDetail .el-dialog__body {
  padding: 0px;
}
.myParkEditOrDetail .myParkInput {
  width: 220px;
}
.myParkEditOrDetail .el-row {
  margin-top: 5px;
}
.myParkEditOrDetail .el-radio {
  line-height: 2px;
}
.myParkEditOrDetail .is-disabled .el-input__inner,
.myParkEditOrDetail .is-disabled .el-textarea__inner {
  color: #606266;
}
/* tab 样式 */
.myParkEditOrDetail .el-tabs__item {
  padding: 0px 20px 0px 0px;
}
.myParkEditOrDetail .el-tabs__nav-scroll {
  background-color: #ccc;
  text-align: center;
  width: 110px;
  overflow: auto;
}
.myParkEditOrDetail .el-tabs__nav-next,
.myParkEditOrDetail .el-tabs__nav-prev {
  display: none;
}
.myParkEditOrDetail .el-tabs__nav-wrap.is-scrollable {
  padding: 0px !important;
}
.myParkEditOrDetail .el-tabs--left.el-tabs--card .el-tabs__item.is-left {
  border: none !important;
}
.myParkEditOrDetail .el-tabs__item:hover {
  color: white;
  background-color: #409eff;
}
.myParkEditOrDetail .el-tabs--left.el-tabs--card .el-tabs__nav {
  border-bottom: none;
}
.myParkEditOrDetail
  .el-tabs--left.el-tabs--card
  .el-tabs__nav
  > .el-tabs__item {
  text-align: right;
}
.myParkEditOrDetail .el-tabs__nav {
  margin-top: -1px;
  margin-left: -1px;
}
.myParkEditOrDetail .el-tabs--left .el-tabs__header.is-left {
  margin-right: 0px;
}
.myParkEditOrDetail .el-dialog {
  min-width: 1100px;
}
.myParkEditOrDetail .tip_item .el-form-item__content {
  height: 100px;
  line-height: 22px;
}
</style>
<style scoped>
.tip_item {
  color: red;
}
#pane-editRoadInfo fieldset,
#pane-editRoadInfo_2019 fieldset {
  padding-bottom: 0px;
}
.search_list .t {
  color: #1eb1fb;
  font-weight: 700;
  min-height: 35px;
  line-height: 35px;
  font-size: 14px;
  padding: 0 7px;
}
#parkBaiduMap {
  float: left;
}
.search_list .a {
  min-height: 20px;
  line-height: 20px;
  font-size: 14px;
  color: #666;
  padding: 0 7px;
}
.search_list {
  height: 300px;
  width: 300px;
  overflow-y: auto;
  float: left;
}
.search_list .el-row {
  margin-top: 0px;
}
.search_list .el-row.selected,
.search_list .el-row:hover {
  background: #dcd9d9;
  cursor: pointer;
}
.parkMain_BaseInfo .el-select {
  width: 100%;
}

.el-form-item {
  margin-bottom: 0px;
}
.dialog-video-wrapper .el-dialog__body {
  padding: 5px;
}
.myel-input__inner {
  height: 20px;
  line-height: 20px;
}
#pane-editRoadInfo legend,
#pane-editRoadInfo_2019 legend {
  display: block;
  width: 100%;
  padding: 0;
  margin-bottom: 10px;
  line-height: inherit;
  color: #333;
  border: 0;
  border-bottom: 1px solid #e5e5e5;
}
#pane-editRoadInfo fieldset,
#pane-editRoadInfo_2019 fieldset {
  margin: 0 2px;
  border: 0px solid silver;
}
.trans_row {
  padding-top: 20px;
  border-top: 1px solid #e5e5e5;
}
.tab_foot {
  width: 110px;
  height: 80px;
  background: #ccc;
}
.dialog-footer {
  text-align: right;
  padding: 20px;
}
.searchRowAdd {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/parkView.vue